import StatusChip from 'components/@extended/StatusChip';
import { RiskProfileType } from 'types/compliance';
import { getClassifierText, t } from 'utils/getTranslations';
import { useClassifiers } from 'utils/useClassifiers';

const RISK_PROFILE_CLASSIFIERS = ['RISK_PROFILE_TYPE'];

interface ClientRiskProfileChipProps {
    riskProfileTypeCode: RiskProfileType | undefined;
}

export function ClientRiskProfileChip({ riskProfileTypeCode }: ClientRiskProfileChipProps) {
    const { classifiers } = useClassifiers({ codes: RISK_PROFILE_CLASSIFIERS });

    if (!riskProfileTypeCode) {
        return <StatusChip type="warning" label={t('matters.no-risk-profile')} />;
    }

    return (
        <StatusChip type="neutral" label={getClassifierText(classifiers['RISK_PROFILE_TYPE'], riskProfileTypeCode)} />
    );
}
